import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import packkagee from "../../../package.json";
import { admission } from "../ADMISSION";

export default class Insertpresent8 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      fileimage: null,
      fileimage_name: null,
      openinsdoc: true,
      showphoto: false,
      ShowfileUpload: [],
      croppedImgSrc: null,
    };
    this.openinsertdocument = this.openinsertdocument.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCropChange = this.handleCropChange.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        admission+"/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
      });

    axios
      .get(
        admission+"/student_insertpresent8/ShowfileUpload/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((res) => {
        console.log(res.data)
        if (res.data.length !== 0) {
          if (
            res.data[0]["UPLOAD_LOGIN"] === null ||
            res.data[0]["UPLOAD_LOGIN"] === "" ||
            res.data[0]["UPLOAD_LOGIN"] === undefined ||
            res.data[0]["UPLOAD_LOGIN"] === "null"
          ) {
            this.setState({ openinsdoc: true });
            this.setState({ showphoto: false });
            this.setState({ ShowfileUpload: null });
          } else {
            this.setState({ openinsdoc: false });
            this.setState({ showphoto: true });
            this.setState({ ShowfileUpload: res.data });
          }
        }
      });
  }

  handleChange(event) {
    event.preventDefault();
    var namefile = event.target.files[0].name;
    namefile = namefile.split(".");
    this.getBase64(event.target.files[0], (files) => {
      files = files.replace("data:image/jpeg;base64,", "data:image/png;base64,");
      this.setState({ [event.target.name]: files });
      this.setState({
        [event.target.name + "_name"]: localStorage.getItem("ID_LOGIN") + "." + namefile[1],
      });
    });
  }

  getBase64(files, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(files);
  }

  handleSubmit(event) {
    event.preventDefault();

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    let bodydata = {
      bdate: this.state.bdate,
      UserID: localStorage.getItem("ID_LOGIN"),
      typedocument: "1",
      imgurl: this.state.croppedImgSrc,
      REGISTER_ID: this.state.REGISTER_ID,
    };
    // axios.post("https://git.kpru.ac.th/admission2017/student_insertpresent8/fileUpload/", bodydata, {headers: headers}).then((data) => {
    axios
      .post(
        admission+"/student_insertpresent8/fileUpload/",
        bodydata,
        {
          headers: headers,
        }
      )
      .then((data) => {
        window.location.href = "/" + packkagee.name + "/Insertpresent9";
      });
  }

  openinsertdocument(event) {
    this.setState({ openinsdoc: true });
  }

  handleCropChange(event) {
    const croppedImgData = event.target.cropper.getCroppedCanvas().toDataURL();
    this.setState({ croppedImgSrc: croppedImgData });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลรูปประจำตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลรูปประจำตัว มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลรูปประจำตัว มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>

          <MDBRow>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
            <MDBCol lg="10" md="12" sm="12">
              <MDBCard>
                <MDBCardBody>
                  <MDBContainer fluid>
                    <MDBRow>
                      <MDBCol>
                        <MDBCardTitle>ข้อมูลรูปประจำตัว</MDBCardTitle>
                        <MDBCardText>
                          <span className="text-danger">
                            * หมายเหตุ <br />
                            1. นักศึกษาภาคปกติ อัพรูปถ่ายภาพสีหน้าตรง ไม่สวมหมวก ไม่สวมแว่นตาดำ
                            สวมชุดนักเรียนของสถาบันการศึกษาที่ท่านศึกษาอยู่
                            <br />
                            2. นักศึกษาภาคกศ.บป. อัพรูปถ่ายภาพสีหน้าตรง ไม่สวมหมวก ไม่สวมแว่นตาดำ
                            สวมชุดสุภาพหรือชุดสูท
                            <br />
                            3. นักศึกษาปริญญาโทหรือปริญญาเอก อัพรูปถ่ายภาพสีหน้าตรง ไม่สวมหมวก
                            ไม่สวมแว่นตาดำ สวมชุดสูท
                            <br />
                            4. นักศึกษาภาคป.วิชาชีพครู อัพรูปถ่ายภาพสีหน้าตรง ไม่สวมหมวก
                            ไม่สวมแว่นตาดำ สวมชุดสูท
                            <br />
                          </span>
                          <span>
                            <div>ตัวอย่างรูปประจำตัว</div>
                            <img
                              src="https://admission.kpru.ac.th/admission2017/public/uploaddocument/6400454/64004541.png"
                              style={{ maxWidth: "100px" }}
                            />
                          </span>
                          <MDBRow>
                            <MDBCol lg="12" md="12" sm="12">
                              {this.state.openinsdoc ? (
                                <>
                                  <form onSubmit={this.handleSubmit}>
                                    <MDBRow>
                                      <MDBCol lg="8" md="8" sm="12">
                                        <div className="form-outline">
                                          <label className="form-label" for="fileimage">
                                            เลือกรูปภาพ <span style={{ color: "red" }}>*</span>
                                          </label>
                                          &nbsp;&nbsp;&nbsp;&nbsp;
                                          <label for="fileimage" className="custom-file-upload">
                                            <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                                          </label>
                                          <input
                                            type="file"
                                            className="form-control"
                                            id="fileimage"
                                            name="fileimage"
                                            accept="image/jpeg,image/png"
                                            onChange={this.handleChange}
                                            required
                                          />{" "}
                                          <span>{this.state.fileimage_name}</span>
                                          <br />
                                        </div>
                                        {this.state.fileimage ? (
                                          <>
                                            <Cropper
                                              style={{ width: 450, height: 450 }}
                                              src={this.state.fileimage}
                                              cropend={this.handleCropChange}
                                              aspectRatio={3.3 / 4}
                                              guides={false}
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </MDBCol>
                                      <MDBCol lg="4" md="4" sm="12">
                                        {this.state.croppedImgSrc ? (
                                          <>
                                            <div className="mt-2">
                                              <div>ตัวอย่างรูปโปรไฟล์ :</div>
                                              <div>
                                                <img
                                                  src={this.state.croppedImgSrc}
                                                  style={{ maxWidth: "100px" }}
                                                />{" "}
                                                &nbsp;
                                                <img
                                                  src="https://admission.kpru.ac.th/admission2017/public/uploaddocument/6400454/64004541.png"
                                                  style={{ maxWidth: "100px" }}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </MDBCol>
                                    </MDBRow>

                                    {this.state.croppedImgSrc ? (
                                      <>
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-rounded btn-md mt-2"
                                        >
                                          บันทึกข้อมูล
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-rounded btn-md mt-2"
                                          disabled
                                        >
                                          บันทึกข้อมูล
                                        </button>
                                      </>
                                    )}
                                  </form>
                                </>
                              ) : (
                                <></>
                              )}

                              {this.state.showphoto ? (
                                <>
                                  <table className="table table-hover">
                                    <thead>
                                      <tr className="table-info">
                                        <th>#</th>
                                        <th>ไฟล์</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.ShowfileUpload.map((data, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <img
                                                src={
                                                  "https://admission.kpru.ac.th/admission2017/" +
                                                  data.UPLOAD_LOGIN
                                                }
                                                width="100px"
                                              />
                                              &nbsp;&nbsp;&nbsp;&nbsp;
                                              {data.UPLOAD_LOGIN !== null ? (
                                                <>
                                                  <a
                                                    href={
                                                      "https://admission.kpru.ac.th/admission2017/" +
                                                      data.UPLOAD_LOGIN
                                                    }
                                                    target="_blank"
                                                    className="btn btn-success btn-sm"
                                                    role="button"
                                                  >
                                                    ดูไฟล์รูปประจำตัว
                                                  </a>
                                                  <button
                                                    type="button"
                                                    className="btn btn-warning btn-sm"
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    แก้ไขไฟล์รูปประจำตัว
                                                  </button>
                                                  {data.UPLOAD_LOGIN_STATUS === "0" ? (
                                                    <>
                                                      <br />
                                                      <text className="text-danger ">
                                                        รูปประจำตัวไม่ผ่าน เนื่องจาก
                                                        {data.UPLOAD_LOGIN_DETAIL}
                                                      </text>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  <button
                                                    type="button"
                                                    className="btn btn-info btn-sm"
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    แนบไฟล์รูปประจำตัว
                                                  </button>
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBCol>
                          </MDBRow>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </MDBContainer>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
          </MDBRow>
        </MDBContainer>
      </>
    );
  }
}
